<template>
  <RightInfoPanelGeneric
    :value="value"
    :title-key="'common.products'"
    :items="items"
    :saving="saving"
    @save="$emit('save')"
    @back="$emit('goto-list')"
  />
</template>

<script>
import RightInfoPanelGeneric from "@/components/Common/RightInfoPanelGeneric.vue";

export default {
  name: "SMProductsRightPanel",
  components: {
    RightInfoPanelGeneric,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return [
        {
          labelKey: "common.name",
          path: "name",
          required: true,
        },
        {
          labelKey: "stock_management.products.type",
          path: "product_type.name",
          required: true,
          formatter: (val, row) => val || row?.product_type?.name || "*",
        },
        {
          labelKey: "stock_management.products.select_mu",
          path: "measure_unit.name",
          required: true,
          formatter: (val, row) => val || row?.measure_unit?.name || "*",
        },
        {
          labelKey: "stock_management.products.barcode",
          path: "barcode",
        },
        {
          labelKey: "stock_management.products.code",
          path: "code",
        },
        {
          labelKey: "stock_management.products.base_product",
          path: "fito_fertility_product_name",
        },
      ];
    },
  },
};
</script>
